if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="language_code"], input[name="country_code"]'
          ),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      isLocalProxy() {
        const host = window.location.hostname;
        return host === '127.0.0.1' || host === 'localhost';
      }

      /**
       * Keep a slash between locale root and the page:
       * /fr + pages/cookies must become /fr/pages/cookies, never /frpages/cookies.
       * Local theme:dev still uses language-only /fr/ (Markets /fr-be/ 404s on the proxy).
       */
      buildLocalLocaleUrl({ languageIso, explicitRoot }) {
        let rest = window.location.pathname || '/';
        rest = rest.replace(
          /^\/[a-z]{2}(?:-[a-z]{2})?(?=pages|products|collections|cart|blogs|policies|account|search)/i,
          '/'
        );
        rest = rest.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
        if (!rest.startsWith('/')) rest = `/${rest}`;

        const iso = String(languageIso || (window.Shopify && Shopify.locale) || 'en').toLowerCase();
        let newRoot = '/';

        if (this.isLocalProxy()) {
          if (iso === 'en-gb' || iso === 'en_gb') {
            newRoot = '/en-gb/';
          } else {
            const lang = iso.split('-')[0];
            if (lang && lang !== 'en') newRoot = `/${lang}/`;
          }
        } else if (explicitRoot) {
          newRoot = String(explicitRoot);
          if (newRoot !== '/' && !newRoot.endsWith('/')) newRoot += '/';
        } else if (iso === 'en-gb' || iso === 'en_gb') {
          newRoot = '/en-gb/';
        } else {
          const lang = iso.split('-')[0];
          if (lang && lang !== 'en') newRoot = `/${lang}/`;
        }

        if (newRoot !== '/') {
          if (!newRoot.startsWith('/')) newRoot = `/${newRoot}`;
          if (!newRoot.endsWith('/')) newRoot = `${newRoot}/`;
        }

        const path =
          rest === '/'
            ? newRoot === '/'
              ? '/'
              : newRoot
            : newRoot === '/'
              ? rest
              : `${newRoot.replace(/\/$/, '')}${rest}`;
        return `${path}${window.location.search || ''}${window.location.hash || ''}`;
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const link = event.currentTarget;
        const value = link.dataset.value;
        if (!value) return;

        const isCountry = !!(this.elements.input && this.elements.input.name === 'country_code');
        const nextUrl = this.buildLocalLocaleUrl({
          languageIso: isCountry ? (window.Shopify && Shopify.locale) || 'en' : value,
          explicitRoot: isCountry ? undefined : link.dataset.rootUrl || undefined,
        });

        if (this.isLocalProxy()) {
          if (isCountry) {
            try {
              localStorage.setItem('ll-dev-country', value.toUpperCase());
            } catch (e) {}
          }
          window.location.assign(nextUrl);
          return;
        }

        // Language switch: go to /fr/pages/cookies ourselves.
        // Shopify's POST /localization often concatenates /fr + pages/cookies
        // into /frpages/cookies (404). Opening cookies from the footer works
        // because those links already include the slash.
        if (!isCountry) {
          window.location.assign(nextUrl);
          return;
        }

        if (!form || !this.elements.input) return;
        this.ensureReturnTo(form, nextUrl);
        this.elements.input.value = value;
        form.submit();
      }

      ensureReturnTo(form, url) {
        let input = form.querySelector('input[name="return_to"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'return_to';
          form.appendChild(input);
        }
        input.value = url;
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
